import React, { useState } from 'react';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

interface CollapsibleFiltersProps {
  // Varsayılandan farklı olan filtre sayısı (butonda rozet olarak gösterilir)
  activeCount?: number;
  onClear?: () => void;
  // Masaüstü (md+) yerleşimi; mobilde her zaman tek sütun tam genişlik kullanılır
  desktopClassName?: string;
  children: React.ReactNode;
}

// Mobilde filtreleri bir "Filtreler" butonunun arkasına katlar ki liste ilk ekranda görünsün.
// Masaüstünde filtreler her zaman açık ve mevcut yerleşimleriyle gösterilir.
const CollapsibleFilters: React.FC<CollapsibleFiltersProps> = ({
  activeCount = 0,
  onClear,
  desktopClassName = 'md:flex md:flex-wrap md:items-center md:gap-3',
  children
}) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div className="flex items-center gap-2 md:hidden">
        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          className="flex-1 flex items-center justify-between px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 text-sm font-medium"
        >
          <span className="flex items-center gap-2">
            <SlidersHorizontal className="w-4 h-4" />
            {t('common.filters')}
            {activeCount > 0 && (
              <span className="min-w-5 h-5 px-1.5 rounded-full bg-primary text-white text-xs flex items-center justify-center">
                {activeCount}
              </span>
            )}
          </span>
          <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {onClear && activeCount > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="px-3 py-2.5 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
          >
            {t('common.clearFilters')}
          </button>
        )}
      </div>
      <div
        className={`${open ? 'grid' : 'hidden'} grid-cols-1 gap-3 mt-3 [&>*]:w-full md:mt-0 md:[&>*]:w-auto ${desktopClassName}`}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleFilters;
